import "../styles/components/faq.css";
import Accordion from "./Accordion";

function Faqs() {
    const data = [
   
        {
            question: "¿Cómo funciona la app?",
            answer: "La app te permite publicar una oferta para que un cocinero profesional venga a tu casa a preparar una comida, unos tuppers o una gran velada. Simplemente selecciona el tipo de comida que deseas, para cuantas personas, cuantos días ,elige una fecha y hora, y publica la oferta. Un cocinero cercano aceptará la oferta y se dirigirá a tu casa.",
        },
        {
            question: "¿Puedo ver en dónde se encuentra el cocinero antes de que llegue?",
            answer: "Sí, una vez que un cocinero ha aceptado tu oferta, podrás ver su ubicación en tiempo real en el mapa de la app. Esto te permite saber exactamente cuánto tiempo le queda para llegar a tu domicilio.",
        },
        {
            question: "¿Cómo selecciono el tipo de comida que quiero?",
            answer: "Puedes especificar el tipo de cocina (italiana, mexicana, vegetariana, etc.), los platos específicos o cualquier restricción dietética que tengas. También puedes agregar notas adicionales para personalizar tu solicitud.",
        },
        {
            question: "¿Cómo puedo registrarme como cocinero en la app?",
            answer: "Para registrarte, simplemente descarga la app y completa el formulario de inscripción. Deberás proporcionar información sobre tu experiencia, especialidades culinarias, y cargar los documentos necesarios para verificar tu identidad y cualificaciones.",
        },
        {
            question: "¿Cómo encuentro la dirección del eater y cuánto me tomará llegar?",
            answer: "Después de aceptar una oferta, la dirección del eater aparecerá en tu pantalla junto con un mapa que muestra la ruta más rápida para llegar. También puedes ver el tiempo estimado de llegada para que el eater pueda seguir tu progreso en tiempo real.",
        },
        {
            question: "¿Cómo acepto una oferta?",
            answer: "Las ofertas aparecerán en tu pantalla según tu ubicación y disponibilidad. Puedes revisar los detalles de cada oferta y aceptarla si se ajusta a tus preferencias y horario.",
        },
    ];

    return (
        <div className="accordion">
            {data.map((item, index) => (
                <Accordion key={index} title={item.question} description={item.answer} />
            ))}
        </div>
    );
}

export default Faqs;
